import { FIND_STUDENT, FIND_TRANSACTION } from "../../routes";
import customAxios from "../../customAxios";
import { IFindTransactions } from "../../../types/common.interface";

async function findTransaction(props: IFindTransactions) {
  var thisUrl = FIND_TRANSACTION;

  let body: any = {
    populate:
      "student driver company parent superAgent city factorsList payerId",
    page: props?.page,
    limit: props?.limit,
  };

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        path : props?.search?.path ,
        base : props?.search?.base ,
        value: props?.search?.value,
      },
    };
  }

  if (props?.search2?.value) {
    body = {
      ...body,
      search2: {
        path : props?.search2?.path ,
        base : props?.search2?.base ,
        value: props?.search2?.value,
      },
    };
  }

  if (props?.filters) {
    const {
      transactionStatus,
      reason,
      superAgent,
      parent,
      school,
      company,
      driver,
      student,
      isDeposit,
      getway,
      city,
      payerOriginType
    } = props.filters;

    body = {
      ...body,
      transactionStatus,
      reason,
      superAgent,
      parent,
      school,
      company,
      driver,
      student,
      isDeposit,
      getway,
      city,
      payerOriginType
    };
  }

  // ?? Academic year (سال تحصیلی) scope. A transaction inherits the year of the service it was raised against.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findTransaction;
